import * as z from "zod/v4";

export const getAiSubjectLineSuggestions = {
  name: "getAiSubjectLineSuggestions" as const,
  input: z.object({
    text: z.string(),
    tone: z.string().optional(),
  }),
  output: z.array(
    z.object({
      text: z.string(),
      tone: z.string(),
    }),
  ),
};
